import React from 'react';

import Image from '../../../../library/image/image';
import Tabs, { Tab } from '../../../../library/tabs/tabs';
import Typography from '../../../../library/typography/typography';
import { TireRegularIcon } from '../../../../shared/icons/icons';
import { PLP_TAB_BANNER_TYPES } from '../../product-list-page-constants';

import {
  useMediaQuery,
  useTreadwellPreferences
} from '../../../../shared/hooks/hooks';

import { trackAction } from '../../../../shared/utils/analytics/analytics';

import styles from './product-list-tabs.scss';

interface ProductListTabsProps {
  clearSelectedFilters: () => void;
  onShopTiresCTAClick?: () => void;
  selectedProductBannerTab?: keyof typeof PLP_TAB_BANNER_TYPES;
  setSelectedProductBannerTab?: (value: boolean) => void;
}

function ProductListTabs(props: ProductListTabsProps) {
  const {
    clearSelectedFilters,
    onShopTiresCTAClick,
    selectedProductBannerTab,
    setSelectedProductBannerTab
  } = props;
  const { treadwellPreferences } = useTreadwellPreferences();
  const { isMinSm } = useMediaQuery();

  const isTiresTabSelected =
    selectedProductBannerTab === PLP_TAB_BANNER_TYPES.TIRES;
  const isTreadwellTabSelected =
    selectedProductBannerTab === PLP_TAB_BANNER_TYPES.TREADWELL;

  const onTabSelected = tab => {
    trackAction('plp_tab_switch');
    setSelectedProductBannerTab?.(tab);
    if (treadwellPreferences) {
      onShopTiresCTAClick?.();
    } else {
      clearSelectedFilters();
    }
  };

  return (
    <Tabs className={styles['tabs-container']}>
      <Tab
        isSelected={isTreadwellTabSelected}
        onClick={() => onTabSelected?.(PLP_TAB_BANNER_TYPES.TREADWELL)}
      >
        <Image
          alt="Treadwell"
          className={styles['treadwell-icon']}
          height={isMinSm ? '24px' : '18px'}
          src="https://discounttire.scene7.com/is/content/discounttire/logos/treadwell-icon-only-trademark.svg"
          width={isMinSm ? '24px' : '18px'}
        />
        <Typography
          size={isMinSm ? '' : 'small'}
          tag="span"
          variant={isMinSm ? 'H5' : 'P'}
        >
          Treadwell® Tire Match
        </Typography>
      </Tab>
      <Tab
        isSelected={isTiresTabSelected}
        onClick={() => onTabSelected?.(PLP_TAB_BANNER_TYPES.TIRES)}
      >
        <Typography
          size={isMinSm ? '' : 'small'}
          tag="span"
          variant={isMinSm ? 'H5' : 'P'}
        >
          {' '}
          <TireRegularIcon />
          All Tires
        </Typography>
      </Tab>
    </Tabs>
  );
}

export default ProductListTabs;
